import Vue from 'vue';
import VueRouter from 'vue-router';
import FyseoView from '../views/FyseoView.vue';
import YzView from '../views/YzView.vue';
import Fy404View from '../views/Fy404View.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/fy',
    name: 'FyseoView',
    component: FyseoView,
  },
  {
    path: '/yz', 
    name: 'YzView',
    component: YzView,
  },
  {
    path: '/:random1/:random2/:random3',
    name: 'RandomFyseoView',
    component: FyseoView,
  },
  {
    path: '/404',
    name: '404',
    component: Fy404View,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Wildcard',
    component: FyseoView,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;